<template>
  <BasicLayout>
    <template #wrapper>
      <Reward ref="RewardRef" :single="true" />
      <el-tabs active-name="-1" tab-position="left" style="background-color: #FFFFFF;height: 100%">
        <el-tab-pane name="-1" label="基础配置">
          <el-card>
            <div slot="header" class="clearfix"><span>基础配置</span></div>
            <el-form class="demo-form-inline">
              <el-form-item label="开关">
                <el-switch v-model="formData.switch" active-text="开启" inactive-text="关闭" :active-value="1" :inactive-value="0" />
              </el-form-item>
              <el-form-item label="开启等级">
                <el-input v-model="formData.openLv" placeholder="开启等级" style="width: 20%"/>-
                <el-input v-model="formData.openLvMax" placeholder="开启等级" style="width: 20%"/>
              </el-form-item>
              <el-form-item label="开启天数">
                <el-input v-model="formData.openDays" placeholder="开启天数" style="width: 40%"/>
              </el-form-item>
              <el-form-item label="价格配置">
                <el-table size="mini" :data="formData.price" border style="width: 40%;min-height: 100px;" highlight-current-row>
                  <el-table-column prop="num">
                    <Price :limit-type="[2]" />
                  </el-table-column>
                </el-table>
              </el-form-item>
              <el-button size="mini" v-permisaction="['config:advertConfig:add']"  type="primary" @click="handleSaveGroup()">保存</el-button>
              <clear-cache-apply />
            </el-form>
          </el-card>
        </el-tab-pane>
        <el-tab-pane name="0" label="奖励配置">
          <el-card class="box-card">
            <el-table size="mini" :data="formData.reward" border style="width: 100%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="序号" width="50">
                <template slot-scope="{row, $index}">
                  <span style="display:block">{{ $index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="num" label="等级">
                <template slot-scope="scope">
                  <el-input v-model.number="scope.row.num" placeholder="等级" />
                </template>
              </el-table-column>
              <el-table-column prop="is_special" label="是否激励层">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.is_special">
                    <el-option v-for="(item, index) in valueArr" :key="index" :label="item.label" :value="item.value"/>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="props" label="普通奖励">
                <template slot-scope="scope">
                  <Reward :value="scope.row.props" />
                </template>
              </el-table-column>
              <el-table-column prop="special" label="付费奖励">
                <template slot-scope="scope">
                  <Reward :value="scope.row.special" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template slot-scope="{row,$index}">
                  <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteGroupConfig($index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="addGroupConfig()">新增</el-button>
              <el-button type="primary" size="mini" style="margin:10px 10px" @click="handleSaveGroup()">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </template>
  </BasicLayout>
</template>

<script>

import Reward from '@/components/Reward/index.vue'
import CommonExcel from '@/components/CommonExcel'
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
import Price from "@/components/Price";

export default {
  name: 'trafficPermitLv',
  components: {Price, SyncData, ClearCacheApply, CommonExcel, Reward },
  data() {
    return {
      formData: {switch:0,openLv:10,openLvMax:50,openDays:30,price:[],reward:[]},
      groupConfig: [],
      curClass: 'trafficPermitLv',
      valueArr: [{ label: '否', value: 0 }, { label: '是', value: 1 }]
    }
  },
  created() {
    this.initCfg()
  },
  methods: {
    initCfg() {
      getCommonCfg({ name: this.curClass }).then(res => {
        this.formData = res.data
        if(this.formData.price.length==0){
          this.formData.price.push({ mtype: 2, bet: 1, sku: '', price: 0, coin: '' })
        }
      })
    },
    deleteGroupConfig(index) {
      this.formData.reward.splice(index, 1)
    },
    addGroupConfig() {
      this.formData.reward.push({ num: 1, is_special: 0, props: [], special: [] })
    },
    handleSaveGroup() {
      let lv = []
      for (let i = 0; i < this.formData.reward.length; i++) {
        if (lv.includes(this.formData.reward[i].num)) {
          this.msgError('等级重复')
          return
        }
        lv.push(this.formData.reward[i].num)
      }
      updateCommonCfg({ name: this.curClass, data: JSON.stringify(this.formData) }).then(res => {
        this.msgSuccess('保存成功')
      })
    }
  }
}
</script>

<style scoped>
</style>
